import { Text } from '@react-spectrum/s2';
import { style } from '@react-spectrum/s2/style' with { type: 'macro' };

import { cn } from '@/utils/cn.ts';

interface InfoRowProps {
	label: string;
	value: string;
	isPlaceholder?: boolean;
	isLast?: boolean;
}

export function InfoRow({
	label,
	value,
	isPlaceholder = false,
	isLast = false,
}: InfoRowProps) {
	return (
		<div
			className={cn(
				'flex items-center justify-between gap-4 py-3',
				!isLast && 'border-b border-(--glass-border)',
			)}
		>
			<Text
				styles={style({
					font: 'body',
					fontSize: 'body',
					color: 'body',
				})}
			>
				{label}
			</Text>
			<Text
				styles={style({
					font: 'body',
					fontSize: 'body',
				})}
				UNSAFE_className={
					isPlaceholder
						? 'text-right text-gray-500 italic'
						: 'text-right text-(--text-primary)'
				}
			>
				{value}
			</Text>
		</div>
	);
}
